import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["view", "edit", "form"]

  toggle() {
    this.viewTarget.classList.toggle("hidden")
    this.editTarget.classList.toggle("hidden")
  }

  submit() {
    this.formTarget.requestSubmit()
  }
}
